
import IState from '@/interfaces/IState';
import { ActionContext } from 'vuex';

export default async (context: ActionContext<IState, IState>, accessLevelId:string) => {
    if (!accessLevelId) {
        return Promise.reject('Incorrect access level id');
    }
    try {
        const accessLevel = await context.dispatch('backendTalker', {
            request: 'access_level_detail',
            id: accessLevelId
        });
        if (!accessLevel) {
            return Promise.reject('Incorrect access level data from backend');
        }
        return accessLevel.data;
    } catch (err) {
        return Promise.reject(err);
    }
};
